import { usePlatformsSectionContent } from './usePlatformsSectionContent';
import { parsePlatformsDidContent } from '../utils/platformsContent';

export const usePlatformsDidContent = () =>
  usePlatformsSectionContent(parsePlatformsDidContent);
